import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import { isNil } from 'lodash';
import React, { useRef, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';

import ArrowButton from './ArrowButton';
import AlignLeft from '../Alignments/AlignLeft';
import AlignRight from '../Alignments/AlignRight';

const useStyles = makeStyles({
  topArrowBar: {
    fontFamily: 'Proxima Nova, Nunito Sans, sans-serif',
    color: '#444444',
    borderWidth: 1,
    borderColor: '#e9e9e9',
    borderStyle: 'solid',
    transition: 'all 100ms linear',
  },
  arrowHolder: {
    display: 'flex',
    margin: '0',
    width: '100%',
  },
  contentContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  detailFormContainer: {
    padding: '0 32px 0 8px',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundColor: '#fff',
  },
  alignItemRight: {
    marginLeft: 'auto',
    marginRight: '0',
  },
  parentDiv: {
    overflow: 'hidden',
    margin: '0',
    alignItems: 'center',
    color: '#111',
    padding: '0px',
  },
  hideScrollBar: {
    marginRight: '-50px !important',
    paddingRight: '50px !important',
  },
});

function CustomGridPanel({
  bgColor,
  children,
  leftBtnDirection,
  onLeftBtnClick = () => {},
  onRightBtnClick = () => {},
  rightBtnDirection,
  widthPercent = 0,
  testAutomation = '',
  hideButtons,
  hideLeftButton,
  hideRightButton,
  isHideScroll,
}) {
  const classes = useStyles();

  const [panelHeight, setPanelHeight] = useState(0);
  const [arrowHolderHeight, setArrowHolderHeight] = useState(0);
  const formattedWidthPercent = `${widthPercent}%`;
  const scrollRef = useRef();

  return (
    <div
      style={{
        width: formattedWidthPercent,
        maxWidth: formattedWidthPercent,
        display: widthPercent === 0 ? 'none' : 'block',
        height: widthPercent === 0 ? '0%' : '100%',
        backgroundColor: bgColor,
      }}
      className={classNames(classes.topArrowBar, classes.parentDiv)}
      ui-ta={testAutomation}
    >
      {!hideButtons && (
        <div className={classes.arrowHolder}>
          {!hideLeftButton && !isNil(leftBtnDirection) && (
            <AlignLeft>
              <ArrowButton direction={leftBtnDirection} onClick={onLeftBtnClick} />
            </AlignLeft>
          )}
          {!hideRightButton && !isNil(rightBtnDirection) && (
            <AlignRight>
              <ArrowButton direction={rightBtnDirection} onClick={onRightBtnClick} />
            </AlignRight>
          )}
          <ReactResizeDetector handleHeight onResize={(w, h) => setArrowHolderHeight(h)} />
        </div>
      )}
      {testAutomation === 'DetailFormPanel' ? (
        <div
          className={
            isHideScroll
              ? classNames(classes.detailFormContainer, classes.hideScrollBar)
              : classes.detailFormContainer
          }
          style={{ height: panelHeight - arrowHolderHeight }}
          ui-ta="ScrollingElement"
          ref={scrollRef}
        >
          {children}
        </div>
      ) : (
        <div
          className={
            isHideScroll
              ? classNames(classes.contentContainer, classes.hideScrollBar)
              : classes.contentContainer
          }
          style={{ height: panelHeight - arrowHolderHeight }}
        >
          {children}
        </div>
      )}
      <ReactResizeDetector handleHeight onResize={(w, h) => setPanelHeight(h)} />
    </div>
  );
}

export default CustomGridPanel;
